<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="12">
              <el-text-field
                label="Pavadinimas (LT)"
                v-model="formData.title_lt"
                :disabled="modeReadonly"
                :maxlength="100"
                required
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-text-field
                label="Pavadinimas (EN)"
                v-model="formData.title_en"
                :disabled="modeReadonly"
                :maxlength="100"
                required
              />
            </v-col>
            <v-col cols="12" md="6">
              <el-text-field
                label="iso code 2"
                v-model="formData.iso_code_2"
                :disabled="modeReadonly"
                :maxlength="2"
                :length="2"
                required
              />
            </v-col>
            <v-col cols="12" md="6">
              <el-text-field
                label="iso code 3"
                v-model="formData.iso_code_3"
                :disabled="modeReadonly"
                :maxlength="3"
                :length="3"
                required
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              v-if="!modeReadonly"
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'

export default {
  name: 'AdminCountryForm',

  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {},
    }
  },
  computed: {
    modeReadonly() {
      return false
    },
    getId() {
      return this.$route.params.id || null
    },
    getTitle() {
      if (this.getId) {
        return this.$t(`Redaguoti šalį`)
      } else {
        return this.$t(`Nauja šalis`)
      }
    },
  },
  beforeDestroy() {},
  created() {
    if (this.getId) {
      this.getData()
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'classifierCountries' })
    },
    getData() {
      this.pageloading = true

      this.$axios
        .get(`countries/${this.getId}`)
        .then((res) => {
          this.formData = res.data.country
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = this.formData
          let url = `countries`
          this.getId && (formData.id = this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
